export const SET_FIREBASE = 'SET_FIREBASE';
export const PRESS_STORAGE_BUTTON = 'PRESS_STORAGE_BUTTON';